import { createContext, useContext, useRef } from 'react'
import { useStore } from 'zustand'

import {
  createDiagnosisRegistrationStore,
  DiagnosisRegistrationStore,
  DiagnosisRegistrationStoreData,
} from './diagnosis-registration-store'

const StoreContext = createContext<DiagnosisRegistrationStore | null>(null)

interface DiagnosisRegistrationStoreProviderProps {
  children: React.ReactNode
}

export function DiagnosisRegistrationStoreProvider({
  children,
}: DiagnosisRegistrationStoreProviderProps) {
  const storeRef = useRef<DiagnosisRegistrationStore | null>(null)

  if (!storeRef.current) {
    storeRef.current = createDiagnosisRegistrationStore()
  }

  return (
    <StoreContext.Provider value={storeRef.current}>
      {children}
    </StoreContext.Provider>
  )
}

export function useDiagnosisRegistrationStore<
  T = DiagnosisRegistrationStoreData,
>(selector?: (state: DiagnosisRegistrationStoreData) => T) {
  const store = useContext(StoreContext)

  if (!store) {
    throw new Error('Missing DiagnosisRegistrationStoreProvider')
  }

  return useStore(store, (state: DiagnosisRegistrationStoreData) =>
    selector ? selector(state) : (state as T),
  )
}
